import React from 'react';
interface ChoiceGroupProps<T extends string> {
  label?: string;
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
  size?: 'sm' | 'md';
}
export function ChoiceGroup<T extends string>({
  label,
  options,
  value,
  onChange,
  size = 'md'
}: ChoiceGroupProps<T>) {
  return <div data-id="element-5315" data-mp="2xjgcxuz3db2f">
      {label && <p className="mb-1.5 text-body-sm font-medium text-ink" data-id="element-5316" data-mp="2xl13zam76bvj">{label}</p>}
      <div role="radiogroup" aria-label={label} className="inline-flex w-full flex-wrap gap-1.5" data-id="element-5317" data-mp="3l90xgiaw8gdt">
        {options.map(option => {
        const active = option === value;
        return <button key={option} type="button" role="radio" aria-checked={active} onClick={() => onChange(option)} className={`min-h-touch rounded-lg border font-medium transition-colors duration-150 ease-out ${size === 'sm' ? 'px-3 py-2 text-body-sm' : 'px-3.5 py-2.5 text-body'} ${active ? 'border-brand-700 bg-brand-50 text-brand-800' : 'border-line-strong bg-surface text-ink-muted hover:border-ink-subtle hover:text-ink'}`} data-id="element-5318" data-mp="3bal5kd41l339">
              {option}
            </button>;
      })}
      </div>
    </div>;
}
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  /** A setting that cannot be changed still shows its true state, not a gap. */
  disabled?: boolean;
}
export function Toggle({
  checked,
  onChange,
  label,
  description,
  disabled = false
}: ToggleProps) {
  return <div className="flex items-start justify-between gap-4 py-2" data-id="element-5319" data-mp="1krd7fkou3h4t">
      <div className="min-w-0" data-id="element-5320" data-mp="1ks6buf0blujs">
        <p className={`text-body font-medium ${disabled ? 'text-ink-muted' : 'text-ink'}`} data-id="element-5321" data-mp="1yqwc23ifsacd">
          {label}
        </p>
        {description && <p className="mt-0.5 text-body-sm text-ink-muted" data-id="element-5322" data-mp="1tte00494hf05">{description}</p>}
      </div>
      {/* 44px hit area around a 24px track: tappable without looking heavy. */}
      <button type="button" role="switch" aria-checked={checked} aria-label={label} disabled={disabled} onClick={() => onChange(!checked)} className="-my-2 -mr-2 flex h-11 w-11 shrink-0 items-center justify-center rounded-md disabled:cursor-not-allowed disabled:opacity-70" data-id="element-5323" data-mp="vfywhs5lbmat">
        <span aria-hidden className={`relative block h-6 w-11 rounded-full border transition-colors duration-150 ease-out ${checked ? 'border-brand-700 bg-brand-700' : 'border-line-strong bg-line'}`} data-id="element-5324" data-mp="1a4d22aue5ov2">
          <span className={`absolute top-0.5 rounded-full bg-white shadow-sm transition-transform duration-150 ease-out ${checked ? 'translate-x-5' : 'translate-x-0.5'}`} style={{
          height: '1.125rem',
          width: '1.125rem'
        }} data-id="element-5325" data-mp="1o4nq764bgpcj" />
        </span>
      </button>
    </div>;
}